import { GET_ACCOUNT_TYPE_REQUEST, GET_ACCOUNT_TYPE_SUCCESS, GET_ACCOUNT_TYPE_FAILURE, GET_ACCOUNT_TYPE_RESET, } from "../../actions";
const initialState = {
    ActivePlanData: null,
    loading: false,
    error: null,
};
const getActiveAccountTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ACCOUNT_TYPE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, ActivePlanData: action.payload });
        case GET_ACCOUNT_TYPE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, ActivePlanData: null, error: null });
        case GET_ACCOUNT_TYPE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, ActivePlanData: null });
        case GET_ACCOUNT_TYPE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, ActivePlanData: null, error: null });
        default:
            return state;
    }
};
export default getActiveAccountTypeReducer;
